import * as Utils from '../utils';

import swedenIcon from '../../assets/svg/sweden-icon.svg';
import denmarkIcon from '../../assets/svg/denmark-icon.svg';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Input } from 'reactstrap';
import InlineSVG from 'react-inlinesvg';


/**
 * 
 * @param {(import('../types').FormV2FieldProps & {value: {country: string; ssn: string;}})} param0 
 */
const SSNV2Field = ({
    field,
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    placeholder,
    lang,
    aria,
    id,
    name,
    type,
    valid,
    data,
    hasError
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const ref = useRef(null);

    const canChangeCountry = typeof window != 'undefined' && localStorage?.getItem?.('ssnSwitchCountries') === 'true' ? field?.config?.preventSSNCountryChange ? false : true : false;
    const country = value?.country;
    const icon = country === 'sweden' ? swedenIcon : country === 'denmark' ? denmarkIcon : null;
    const ssn = value?.ssn || '';

    const countries = useMemo(() => {
        return [
            {
                value: 'denmark',
                icon: denmarkIcon,
                name: 'Denmark'.translate(lang),
            },
            {
                value: 'sweden',
                icon: swedenIcon,
                name: 'Sweden'.translate(lang),
            }
        ]
    }, [lang]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowMenu(false);
            }
        }

        window.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
        }
    }, []);

    return (
        <div className='ssn-field-input-wrap'>
            <Input
                id={id}
                name={name}
                placeholder={placeholder?.translate(lang)}
                value={ssn}
                onChange={e => onChange?.({ ...value, ssn: e.target.value })}
                onBlur={onBlur}
                onFocus={onFocus}
                disabled={isDisabled}
                required={isRequired}
                invalid={hasError}
                valid={valid}
                {...aria || {}}
                autoComplete={field?.config?.autoComplete}
                inputMode='numeric'
                className='pl-60'
            />
            <div className="ssn-field-input-countries-wrap" ref={ref}>
                <div className={`ssn-field-input-selected-country ${canChangeCountry ? '' : 'ssn-field-input-selected-country-noafter'}`} role='button' onClick={() => {
                    if (!canChangeCountry || isDisabled) return;
                    setShowMenu(prev => !prev);
                }}>
                    <InlineSVG src={icon} />
                </div>
                {showMenu ? <div className='ssn-field-input-countries-menu-wrap'>
                    {countries.map(item => <div
                        key={item.value}
                        className={item.value === country ? 'ssn-field-input-countries-menu-item menu-item-active' : 'ssn-field-input-countries-menu-item'}
                        onClick={() => {
                            if (!canChangeCountry || isDisabled) return;
                            if (item.value === country) return setShowMenu(false);

                            onChange?.({ ...value, country: item.value, ssn: '' });
                            setTimeout(() => {
                                setShowMenu(false);
                            }, 100);
                        }}
                    >
                        <InlineSVG src={item.icon} />
                        <p>{item.name}</p>
                    </div>)}
                </div> : null}
            </div>
        </div>
    )
}

export default SSNV2Field